// Bereinigt fremdes HTML (Mails, Teams-Nachrichten), BEVOR es in den
// abgeschotteten Rahmen geht (components/ui/ExternalHtmlFrame). Der Rahmen ist
// die eigentliche Grenze; diese Funktion ist die zweite Linie und raeumt auf,
// was dort ohnehin nichts zu suchen hat.
//
// #285: Hiess bis Sprint 6 sanitizeEmailHtml und lag in zwei wortgleichen
// Kopien vor (EmailDetail und TeamsMessageDetail). Der Name log, sobald der
// Rahmen auch Teams-Nachrichten traegt — nichts hier ist mailspezifisch.
//
// #273: Frueher gab die Funktion nur doc.body.innerHTML zurueck — der <head>
// samt <style> fiel weg. In einer Stichprobe von 500 Produktionsmails tragen
// 431 einen <style>-Block, bei 290 von 300 steht er im <head>. Diese Mails
// wurden dadurch systematisch entstellt. Die <style>-Bloecke aus dem Kopf
// werden jetzt dem Koerper vorangestellt; im Rahmen wirken sie auf das ganze
// Dokument, ohne in die Anwendung auszustrahlen.
//
// Lag als lokale Funktion in EmailDetail.js — hier ist sie fuer sich pruefbar.

// <base> wuerde alle relativen Verweise umbiegen, <link> externes CSS
// nachladen, <meta> koennte die CSP des Rahmens ueberschreiben.
const GEFAEHRLICHE_TAGS = ['base', 'script', 'iframe', 'object', 'embed', 'form', 'link', 'meta'];

// #285: Ein Verweis mit javascript:-Schema ueberlebte bisher jede Bereinigung —
// es gab nirgends eine Schema-Pruefung. Im Rahmen kann er nichts mehr
// ausrichten (keine Skripte per Sandbox UND per CSP), aber eine zweite Linie,
// die einen offensichtlichen Angriffsvektor durchlaesst, ist keine.
// Die Entitaeten-Variante (&#106;avascript:) ist hier schon aufgeloest, weil
// DOMParser das beim Parsen erledigt.
const URL_ATTRIBUTE = ['href', 'src', 'xlink:href', 'action', 'formaction', 'background', 'poster'];
// Der Doppelpunkt gehoert ins Muster: sonst faellt auch ein harmloses
// relatives Ziel wie "javascript-anleitung.html" darunter.
const AUSFUEHRENDE_SCHEMATA = /^(?:(?:javascript|vbscript|livescript|mocha):|data:text\/html)/i;

const istGefaehrlicheUrl = (wert, attribut) => {
  // Steuerzeichen und Leerraum raus: "java\tscript:" ist fuer den Browser
  // dasselbe Schema, fuer einen naiven Vergleich aber nicht.
  const normalisiert = String(wert == null ? '' : wert)
    // eslint-disable-next-line no-control-regex -- genau darum geht es hier: Steuerzeichen tarnen das Schema
    .replace(/[\u0000-\u0020\u007f]/g, '')
    .toLowerCase();
  if (AUSFUEHRENDE_SCHEMATA.test(normalisiert)) return true;
  // data: taugt als Bildquelle, als Ziel eines Verweises aber nur zum
  // Unterschieben eines eigenen Dokuments.
  if (attribut === 'href' && normalisiert.startsWith('data:')) return true;
  return false;
};

export const sanitizeExternalHtml = (html) => {
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(String(html), 'text/html');

    for (const tag of GEFAEHRLICHE_TAGS) {
      doc.querySelectorAll(tag).forEach(el => el.remove());
    }

    // Inline-Ereignisbehandler (on*) und ausfuehrbare Verweisziele entfernen
    doc.querySelectorAll('*').forEach(el => {
      try {
        Array.from(el.attributes).forEach(attr => {
          const name = attr.name.toLowerCase();
          if (/^on/i.test(name)) {
            el.removeAttribute(attr.name);
            return;
          }
          if (URL_ATTRIBUTE.includes(name) && istGefaehrlicheUrl(attr.value, name)) {
            el.removeAttribute(attr.name);
          }
        });
      } catch (_) {}
    });

    const kopfStile = doc.head
      ? Array.from(doc.head.querySelectorAll('style')).map(el => el.outerHTML).join('')
      : '';
    const koerper = doc.body ? doc.body.innerHTML : '';
    return kopfStile + koerper;
  } catch (_) {
    return html;
  }
};

export default sanitizeExternalHtml;
